export default __webpack_public_path__ + "static/media/corevalue-respect.146df48f.png";